function extend(to, _from) {
    for (let key in _from) {
        to[key] = _from[key];
    }
    return to;
};
function build_message(message_arrar) {
    var messages={};
    for (let key in message_arrar) {
        messages= extend(messages,message_arrar[key]);
    }
    return messages;
}

export default build_message


// WEBPACK FOOTER //
// ./src/lan/build_message.js